import { LicenseCategory } from '@enmon/commons/lib/enmon';

export const LICENSE_CATEGORY_TRANSLATED: Record<LicenseCategory, string> = {
  [LicenseCategory.Customers]: 'Customers',
  [LicenseCategory.Establishments]: 'Establishments',
  [LicenseCategory.MetersOnline]: 'Meters online',
  [LicenseCategory.MetersOffline]: 'Meters offline',
};
